import './CustomizeBoard.module.css';

import {
  Button,
  TextField
} from '@material-ui/core';
import { Settings as SettingsIcon } from '@material-ui/icons';
import { uniq } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  setCharacters,
  setNewGame,
  setShowSettings
} from '../../store/actions';
import {
  getIsChinese,
  getShowSettings,
  getSize,
  getSolutionBoard,
  getSudokuBoard
} from '../../store/selectors';
import ChineseFontDropdown from '../ChineseFontDropdown';
import DifficultyButtonGroup from '../DifficultyButtonGroup';
import DownloadJpegButton from '../DownloadJpegButton';
import DownloadPdfButton from '../DownloadPdfButton';
import SettingsDrawer from '../SettingsDrawer';
import SizeButtonGroup from '../SizeButtonGroup';
import SudokuTable from '../SudokuTable';

export default function CustomizeBoard() {
  const dispatch = useDispatch();
  const isChinese = useSelector(getIsChinese);
  const sudokuBoard = useSelector(getSudokuBoard);
  const solutionBoard = useSelector(getSolutionBoard);
  const size = useSelector(getSize);
  const showSettings = useSelector(getShowSettings);

  const [errorMessage, setErrorMessage] = useState(null);

  const inputRef = useRef(null);

  useEffect(() => {
    dispatch(setNewGame());
  }, []);

  const onCustomCharacterButtonClick = () => {
    let charactersToSet = inputRef.current.value.split('');
    charactersToSet = uniq(charactersToSet);
    if (charactersToSet.length === size) {
      dispatch(setCharacters(inputRef.current.value.split('')));
      setErrorMessage(null);
    } else {
      setErrorMessage(`There must be ${size} unqiue characters`);
    }
  };

  return (
    <>
      <SettingsDrawer title="Advanced Settings">
        <ChineseFontDropdown />
      </SettingsDrawer>
      <div styleName="topWrap">
        <div styleName="topControlGroups">
          <DifficultyButtonGroup styleName="buttonGroup" />
          <SizeButtonGroup styleName="buttonGroup" />
        </div>
        <div styleName="inputWrap">
          <TextField
            error={!!errorMessage}
            helperText={errorMessage}
            id="custom-characters"
            inputProps={{ maxLength : size }}
            inputRef={inputRef}
            label="Custom characters"
            placeholder={size === 9 ? 'ex: abcdefghi' : 'ex: abcdef'}
            size="small"
            variant="outlined"
          />
          <div styleName="inputButton">
            <Button
              color="primary"
              onClick={onCustomCharacterButtonClick}
              variant="contained"
            >
              Apply
            </Button>
          </div>
        </div>
      </div>
      {sudokuBoard && (
        <SudokuTable id="sudokuTable" sudokuBoard={sudokuBoard} />
      )}
      {isChinese && (
        <div styleName="bottom">
          <Button
            color="primary"
            onClick={() => { dispatch(setShowSettings(!showSettings)); }}
            startIcon={<SettingsIcon />}
          >
            Change Font
          </Button>
        </div>
      )}
      <div styleName="bottom">
        <DownloadPdfButton elementId="#sudokuTable" fileName="sudoku.pdf">
          Download Sodoku PDF
        </DownloadPdfButton>
        <DownloadJpegButton elementId="#sudokuTable" fileName="sudoku.jpeg">
          Download Sodoku JPEG
        </DownloadJpegButton>
      </div>
      { solutionBoard && (
        <>
          <SudokuTable
            id="solutionTable"
            isSolutionTable
            solutionBoard={solutionBoard}
            sudokuBoard={sudokuBoard}
          />
          <div styleName="bottom">
            <DownloadPdfButton elementId="#solutionTable" fileName="solution.pdf">
              Download Solution PDF
            </DownloadPdfButton>
            <DownloadJpegButton elementId="#solutionTable" fileName="solution.jpeg">
              Download Solution JPEG
            </DownloadJpegButton>
          </div>
        </>
      )}
    </>
  );
}
